"use strict";
/**
 * Create the store with dynamic reducers
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var connected_react_router_1 = require("connected-react-router");
var redux_1 = require("redux");
var reducers_1 = __importDefault(require("./reducers"));
function configureStore(initialState, history) {
    if (initialState === void 0) { initialState = {}; }
    var composeEnhancers = redux_1.compose;
    // If Redux Dev Tools and Saga Dev Tools Extensions are installed, enable them
    /* istanbul ignore next */
    if (process.env.NODE_ENV !== 'production' && typeof window === 'object') {
        /* eslint-disable no-underscore-dangle */
        if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
            composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({});
        }
        // NOTE: Uncomment the code below to restore support for Redux Saga
        // Dev Tools once it supports redux-saga version 1.x.x
        // if (window.__SAGA_MONITOR_EXTENSION__)
        //   reduxSagaMonitorOptions = {
        //     sagaMonitor: window.__SAGA_MONITOR_EXTENSION__,
        //   };
        /* eslint-enable */
    }
    // Create the store with two middlewares
    // 2. routerMiddleware: Syncs the location/URL path to the state
    var middlewares = [(0, connected_react_router_1.routerMiddleware)(history)];
    var enhancers = [redux_1.applyMiddleware.apply(void 0, __spreadArray([], __read(middlewares), false))];
    var store = (0, redux_1.createStore)((0, reducers_1.default)(), initialState, composeEnhancers.apply(void 0, __spreadArray([], __read(enhancers), false)));
    // Extensions
    store.injectedReducers = {}; // Reducer registry
    // Make reducers hot reloadable, see http://mxs.is/googmo
    /* istanbul ignore next */
    /* eslint-disable @typescript-eslint/ban-ts-comment */
    // @ts-ignore
    if (module.hot) {
        // @ts-ignore
        module.hot.accept('./reducers', function () {
            store.replaceReducer((0, reducers_1.default)(store.injectedReducers));
        });
    }
    /* eslint-enable @typescript-eslint/ban-ts-comment */
    return store;
}
exports.default = configureStore;
